import WorkInProgress from "../Components/No Page/workInProgress";

const Home = () => (
  <div>
    <WorkInProgress />
  </div>
);

export default Home;
